export default __webpack_public_path__ + "static/media/loader.4a93b39e.gif";